// extracted by mini-css-extract-plugin
module.exports = {"textArea":"index-shimmer_textArea__2U5hr","placeholderShimmer":"index-shimmer_placeholderShimmer__2clH7"};